export default {
  template: '#vue-product-ship-tile',
  delimiters: ['${', '}'],
  props: ['pid', 'collection', 'product'],
  computed: {
    availability() {
      if (this.product && this.product.availability) {
        return this.product.availability
      }

      if (this.$store.state.product_tile_availability === null) {
        return null
      }
      if (this.$store.state.product_tile_availability === false) {
        return false
      }
      return this.$store.state.product_tile_availability[parseInt(this.pid)] || {
        can_ship: false,
        pickup_25: false,
        pickup_50: false,
        pickup_100: false,
        pickup_250: false,
        pickup_any: false
      }
    }
  },
  beforeCreate() {
    if (this.pid && !this.collection) {
      // stock fetch for search results
      this.$store.commit({type: 'addPidToQuery', value: this.pid})
    }
  },
  mounted() {
    if (this.pid && !this.collection) {
      // do this for search
      this.$store.dispatch("getProductLaneStock")
    }
  }
}